import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login_admin'
import forgetPassword from './modules/forget_password'
import latestMember from './modules/latestMember'
import adminAddMember from './modules/adminAddMember'
import adminEditMember from './modules/adminEditMember'
import adminAccount from './modules/adminAccount'
import adminProperty from './modules/adminProperty'
import adminMagazine from './modules/adminMagazine'
import adminBlog from './modules/adminBlog'
import blogClient from './modules/blogClient'
import propertyClient from './modules/propertyClient'
import contactUs from './modules/contactUs'
import router from '../router'
import planClient from './modules/planClient'
import properties from './modules/properties'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    errors: null,
    apiStatus: null,
    progress: false,
    language: router.currentRoute.params.lang
  },
  getters: {
    errors: state => state.errors,
    apiStatus: state => state.apiStatus,
    progress: state => state.progress,
    propertyStatus: state => state.propertyStatus
  },
  mutations: {
    setErrors (state, errors) {
      state.errors = errors
    },
    setProgress (state, progress) {
      state.progress = progress
    },
    setApiStatus (state, apiStatus) {
      state.apiStatus = apiStatus
    },
    setPropertyStatus (state, propertyStatus) {
      state.propertyStatus = propertyStatus
    }
  },
  actions: {
    getErrors ({ commit }, errors) {
      commit('setErrors', errors)
    }
  },
  modules: {
    login,
    forgetPassword,
    latestMember,
    adminAddMember,
    adminEditMember,
    adminAccount,
    adminProperty,
    adminMagazine,
    adminBlog,
    propertyClient,
    blogClient,
    contactUs,
    planClient,
    properties
  }
})
